export default [
  {
    key: 'account_name',
    label: 'ユーザ名',
    value: '',
  },
  {
    key: 'gender',
    label: '性別',
    value: '',
  },
  {
    key: 'height',
    label: '身長',
    value: '',
  },
  {
    key: 'birthday',
    label: '年齢（生年月日)',
    value: '',
  },
  {
    key: 'goal_weight',
    label: '目標体重',
    value: '',
  },
  {
    key: 'athlete',
    label: 'アスリートモード',
    value: '',
  },
  {
    key: 'created_at',
    label: '登録日時',
    value: '',
  },
  {
    key: 'updated_at',
    label: '更新日時',
    value: '',
  },
]
